import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Dropdown, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { getRoles } from "../../../services/academicService";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Role", sortingVale: "role" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Actions", sortingVale: "actions" },
];

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [allRoles, setAllRoles] = useState([]); // original full list
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  function SotingData(name) {
    const sortedPeople = [...roles];
    switch (name) {
      case "sno":
        sortedPeople.sort((a, b) => {
          return a.sno < b.sno ? -1 : 1;
        });
        break;
      case "name":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name);
        });
        break;
      case "status":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.status.localeCompare(b.status)
            : b.status.localeCompare(a.status);
        });
        break;

      default:
        break;
    }
    setRoles(sortedPeople);
  }

  function DataSearch(e) {
    const updatesDate = allRoles.filter((item) => {
      let selectdata = `${item.name}  ${item.status}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setRoles([...updatesDate]);
  }

  useEffect(() => {
    fetchRoles();
  }, []);

  async function fetchRoles() {
    try {
      const res = await getRoles();
      setRoles(res);
      setAllRoles(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }
  return (
    <>
      <PageTitle activeMenu={"All Roles"} motherMenu={"Security"} />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Role List</h4>
              <Link to={"/admin/add-roles"} className="btn btn-primary">
                + Add New
              </Link>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length"></div>
                    <div className="dataTables_filter">
                      <label>
                        Search :{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={DataSearch}
                        />
                      </label>
                    </div>
                  </div>
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {theadData.map((item, ind) => (
                          <th
                            key={ind}
                            onClick={() => {
                              SotingData(item.sortingVale);
                              setIconDate((prevState) => ({
                                complete: !prevState.complete,
                                ind: ind,
                              }));
                            }}
                          >
                            {item.heading}
                            <span>
                              {ind !== iconData.ind && (
                                <i
                                  className="fa fa-sort ms-2 fs-12"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                              {ind === iconData.ind &&
                                (iconData.complete ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {roles?.map((data, ind) => (
                        <tr key={ind}>
                          <td>
                            <strong>{ind + 1}</strong>{" "}
                          </td>
                          <td>{data.name}</td>
                          <td>{data.status}</td>
                          <td>
                            <Link
                              to="/admin/add-roles"
                              state={{ user: data, mode: "edit" }}
                              className="btn btn-primary shadow btn-s sharp me-1"
                            >
                              <i className="fa fa-pencil" />
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Roles;
